import { useEffect } from "react";

const useClearStorage = (isKioskMode: boolean) => {
  useEffect(() => {
    if (isKioskMode) {
      // The 2000 ms delay allows scripts like GTM to finish setting cookies before we try to clear them.
      setTimeout(() => {
        const cookies = document.cookie.split(";");
        const domains = [
          "", // Current domain
          `.worldvision.org`, // Root domain
          `.${window.location.hostname}` // Current subdomain
        ];
        const paths = ["/", window.location.pathname];

        cookies.forEach((cookie) => {
          const cookieName = cookie.split("=")[0].trim();

          // Skip campaign cookie since we don't want to clear it at this point in the page lifecycle (or at all).
          if (cookieName !== "campaign" && cookieName) {
            // Try to clear cookie with different domain/path combinations.
            // This more thorough approach allows us to clear a broader set of first party cookies.
            domains.forEach((domain) => {
              paths.forEach((path) => {
                const domainPart = domain ? `; domain=${domain}` : "";
                const pathPart = `; path=${path}`;
                document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC${domainPart}${pathPart}`;
              });
            });
          }
        });

        // Clear session storage
        sessionStorage.clear();

        // Clear local storage
        localStorage.clear();
      }, 2000);
    }
  }, [isKioskMode]);
};

export default useClearStorage;
